import React, { useEffect, useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import { useSelector } from "react-redux";
import { avantSolarApi } from "api/authApi";
import Alert from "components/alert";
import DataTableAvantSolar from "components/datatable/datatable";
import { obtenerNombreHuertaId } from "utils/generalFunctions";
import HeaderComponent from "components/Header/header";
import Footer from "components/Footer/Footer";

var ps = null;

function ListadoInversores(props) {
  const mainPanel = React.useRef();
  const location = useLocation();

  const [inversoresCopia, setInversoresCopia] = useState([]);
  const [inversoresPintar, setInversoresPintar] = useState([]);
  const { jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current);
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  });

  const fetchInversores = async () => {
    setError(null);
    setLoading(true);
    try {
      const response = await avantSolarApi.get(
        "/all/inverterList?id_huerta=" + huerta,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;
      console.log(data);
      setLoading(false);
      if (data?.code === 200) {
        setInversoresCopia([...data.data]);
        setInversoresPintar([...data.data]);
      } else {
        setError(data.message);
        setInversoresCopia(null);
        setInversoresPintar(null);
      }
    } catch (error) {
      setError(error.response.data.message);
    }
  };

  useEffect(() => {
    fetchInversores();
  }, [huerta]);

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const headers = [
    [
      "Inversor",
      "Potencia Actual",
      "E.Tot (EST 0.92)",
      "Rend (WA/WP)",
      `Potencia`,
      "Última actualización",
    ],
  ];
  const headersTable = [
    { name: "Inversor", prop: "nombreInversor" },
    { name: "Potencia Actual", prop: "potenciaActual" },
    { name: `E.Tot (EST 0.92)`, prop: "etot" },
    { name: "Rend (WA/WP)", prop: "rend" },
    { name: "Potencia", prop: "potencia" },
    { name: "Última actualización", prop: "fecha" },
  ];

  const properties = [
    "nombreInversor",
    "potenciaActual",
    "etot",
    "rend",
    "potencia",
    "fecha",
  ];

  return (
    <div className="wrapper">
      <Sidebar {...props} routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <div>
          <DemoNavbar {...props} />
          <div className="p-1">
            {!error && (
              <DataTableAvantSolar
                data={inversoresPintar}
                dataCopy={inversoresCopia}
                headersTable={headersTable}
                headers={headers}
                properties={properties}
                loading={loading}
                setData={setInversoresPintar}
                titleProps={
                  "Listado de Inversores - Huerta: " +
                  obtenerNombreHuertaId(huerta)
                }
                name={"listadoInversores"}
                filtros={["nombreInstalacion", "nombreTitular"]}
                placeholderInput={"Filtra por Titular o Instalacion"}
                defaultMostrar={10}
                botonesFiltrado={false}
                scrollBar={ps}
              ></DataTableAvantSolar>
            )}
          </div>
          {error && <Alert message={error} />}
        </div>
        <Footer data={inversoresCopia} />
      </div>
    </div>
  );
}

export default ListadoInversores;
